import { useForm, SubmitHandler, Controller } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

import AuthPage from 'components/AuthPage';
import Input from 'components/Input';
import Button from 'components/Button';

const schema = yup.object().shape({
  email: yup.string().email('Invalid email').required('Email is required'),
  password: yup.string().required('Password is required'),
});

interface ISetPasswordForm {
  email: string;
  password: string;
}

const Login = () => {
  const {
    handleSubmit,
    formState: { isValid, isSubmitted },
    control,
  } = useForm<ISetPasswordForm>({
    defaultValues: { email: '', password: '' },
    mode: 'onBlur',
    resolver: yupResolver(schema),
  });

  const onSubmit: SubmitHandler<ISetPasswordForm> = () => {};

  return (
    <AuthPage>
      <div className='flex flex-col justify-center w-full'>
        <h1 className='bold text-grey800 font-[DKLiquidEmbrace] text-3xl pb-[24px] text-center md:text-left'>Login</h1>

        <form onSubmit={handleSubmit(onSubmit)} className={'flex flex-col gap-[24px] max-sm:gap-[20px]'}>
          <Controller
            control={control}
            name='email'
            render={({ field, fieldState }) => (
              <Input
                type='email'
                label='Email Address'
                placeholder='Enter your email address'
                {...field}
                {...fieldState}
              />
            )}
          />
          <Controller
            control={control}
            name='password'
            render={({ field, fieldState }) => (
              <Input type='password' label='Password' placeholder='Enter your password' {...field} {...fieldState} />
            )}
          />
          <a href='#' className='text-primary font-[MuseoSansCyrl] underline text-[14px] leading-[20px]'>
            Forgot password?
          </a>
          <Button type='submit' styles={'w-full md:w-fit font-semibold'} disabled={!isValid || isSubmitted}>
            Sign In
          </Button>
        </form>
      </div>
    </AuthPage>
  );
};

export default Login;
